<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '420px' }"
    header="Fomulário de Unidades"
    :modal="true"
    @hide="hideDialog"
  >
    <div class="p-fluid formgrid grid">
      <div class="field col-12">
        <label for="und">Nome da Unidade</label>
        <InputText
          id="und"
          v-model="v$.unidade.descricao.$model"
          maxlength="100"
          placeholder="Digite o nome da unidade."
          :class="{ 'p-invalid': submitted && v$.unidade.descricao.$invalid }"
        />
        <small v-if="submitted && v$.unidade.descricao.$invalid" class="p-error"
          >Nome da Unidade é obrigatório.</small
        >
      </div>
    </div>
    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.unidade.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import Unidade from "../../../models/unidade";

//Services
import UnidadeService from "../../../service/unidade/unidadeService";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["selected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      unidade: new Unidade(),
      unidadeService: new UnidadeService(),
      submitted: false,
    };
  },
  validations() {
    return {
      unidade: new Unidade().validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.unidade.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.unidade.dialogForm = value;
      },
    },
  },
  methods: {
    send(isFormValid) {
      this.submitted = true;
      if (isFormValid) {
        if (this.unidade.id) {
          this.update();
        } else {
          this.create();
        }
      } else {
        return;
      }
    },

    create() {
      this.unidadeService
        .create(this.unidade)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.unidadeService
        .update(this.unidade)
        .then((data) => {
          this.$msgSuccess(data);
          this.$emit("findAll");
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.unidade = new Unidade();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.unidade = this.selected;
      this.findUnidades();
    },
    findUnidades() {
      this.unidadeService.findAll().then((data) => {
        this.allUnidades = data;
      });
    },
  },
};
</script>
<style scoped></style>
